export default __webpack_public_path__ + "static/media/IC00043-owl_eye_close.7561ddf2.svg";